"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActionChip = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/styles");
var _Chip = _interopRequireDefault(require("@material-ui/core/Chip"));
var _DeleteIcon = require("../icons/DeleteIcon");
var _Fonts = require("../constants/Fonts");
var _pittaModules = require("@thingsw/pitta-modules");
var _styles2 = require("@material-ui/core/styles");
var _excluded = ["component", "disabled", "label", "deleteIcon"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyle = (0, _styles.makeStyles)(function (theme) {
  return (0, _styles2.createStyles)({
    //@ts-ignore
    root: _objectSpread(_objectSpread({
      textTransform: "none",
      padding: function padding(props) {
        return theme.direction === "rtl" ? props.onDelete ? "6px 8px 6px 0" : "7px 8px 5px" : !props.onDelete ? "7px 8px 5px" : "6px 0 5px 8px";
      }
    }, _Fonts.Fonts.Default.Caption), {}, {
      // minWidth: (props: ActionChipProps) => (props.onDelete ? 102 : 78),
      maxHeight: 28,
      borderRadius: 4,
      backgroundColor: _pittaModules.LightColors.primary["0"],
      border: "1px solid ".concat(_pittaModules.LightColors.primary["4"]),
      "&:hover": {
        border: "1px solid ".concat(_pittaModules.LightColors.primary["4"]),
        backgroundColor: _pittaModules.LightColors.primary["0"],
        color: _pittaModules.LightColors.primary["7"]
      },
      "&:focus": {
        border: "1px solid ".concat(_pittaModules.LightColors.primary["4"]),
        backgroundColor: _pittaModules.LightColors.primary["0"],
        color: _pittaModules.LightColors.primary["7"]
      },
      "&:active": {
        border: "1px solid ".concat(_pittaModules.LightColors.primary["7"]),
        backgroundColor: _pittaModules.LightColors.primary["7"],
        color: _pittaModules.LightColors.primary["0"],
        "&>svg": {
          fill: _pittaModules.LightColors.primary["0"]
        }
      },
      cursor: "pointer"
    }),
    label: {
      // minWidth: 60,
      height: 16,
      padding: 0,
      margin: function margin(props) {
        return theme.direction === "rtl" ? props.onDelete ? "1px 0 0 8px" : 0 : props.onDelete ? "1px 8px 0 0" : 0;
      }
    },
    deleteIcon: {
      width: 24,
      height: 24,
      fontSize: 18,
      margin: 0,
      fill: _pittaModules.LightColors.primary["3"]
    }
  });
});
var ActionChip = function ActionChip(props) {
  var theme = (0, _styles.useTheme)();
  var classes = useStyle(props);
  var component = props.component,
    disabled = props.disabled,
    label = props.label,
    deleteIcon = props.deleteIcon,
    restProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Chip.default, _extends({
    dir: theme.direction,
    classes: classes,
    label: label,
    disabled: disabled,
    deleteIcon: /*#__PURE__*/_react.default.createElement(_DeleteIcon.DeleteIcon, null)
  }, restProps)));
};
exports.ActionChip = ActionChip;